import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { CurrentUserContext } from "../../../contexts/CurrentUserContext";
import { FaSignOutAlt, FaUserShield, FaHome, FaBook } from "react-icons/fa";
import "./HeaderLogin.css";

export default function HeaderLogin({ exitLogin }) {
  const { currentUser } = useContext(CurrentUserContext);
  const isAdmin = currentUser?.roles?.includes("admin");
  const isActivated = currentUser?.isActivated;

  const getLinkClass = ({ isActive }) =>
    `header-login__icon ${isActive ? "header-login__icon_active" : ""}`;

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-container__logo" />

        <ul className="header__link-list header__link-list_login">
          {/* Если пользователь активирован — показываем все ссылки */}
          {isActivated ? (
            <>
              <li className="header__link-item">
                <NavLink to="/" className={getLinkClass} title="Главная" end>
                  <span className="header-login__icon-inner">
                    <FaHome />
                  </span>
                </NavLink>
              </li>

              {isAdmin && (
                <li className="header__link-item">
                  <NavLink
                    to="/admin"
                    className={getLinkClass}
                    title="Админ-панель"
                  >
                    <span className="header-login__icon-inner">
                      <FaUserShield />
                    </span>
                  </NavLink>
                </li>
              )}

              <li className="header__link-item">
                <NavLink
                  to="/content"
                  className={getLinkClass}
                  title="Курс"
                >
                  <span className="header-login__icon-inner">
                    <FaBook />
                  </span>
                </NavLink>
              </li>
            </>
          ) : null}

          {/* Кнопка выхода показывается всегда */}
          <li className="header__link-item">
            <button
              type="button"
              onClick={exitLogin}
              className="header-login__icon header-login__icon_button"
              title="Выход"
            >
              <span className="header-login__icon-inner">
                <FaSignOutAlt />
              </span>
            </button>
          </li>
        </ul>
      </div>
    </header>
  );
}
